import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useMainLocation() {
  const api = useApi()
  const [dataMainLocation, setData] = useState<SelectOptionType[]>([])
  const [isLoadingMainLocation, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/location/")
    .then((res: SuccessFetch<{
      payload: {
        location_id: number
        location_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.location_name, value: item.location_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)
    
    api.get("/location/")
    .then((res: SuccessFetch<{
      payload: {
        location_id: number
        location_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.location_name, value: item.location_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { dataMainLocation, isLoadingMainLocation, refetch }
}